import React from 'react';

const actions = {
    testShare: 4, testDownload: 5, testEdit: 6, testRecord: 104, testDelete: 105,
    userAdd: 7, userEdit: 8, userDeactivate: 9, userActivate: 10, userPswdReset: 11, userUpload: 12,
    shareUserActivate: 27, shareUserDeactivate: 28,
    profileAdd: 1, profileEdit: 2, profileUpload: 3, profileDelete: 101,
    orgAdd: 13, orgEdit: 14, orgDeactivate: 15, orgActivate: 16, orgUpload: 17,
    customerAdd: 31, customerEdit: 32, customerActivate: 33, customerDeactivate: 34,
    empAdd: 35, empEdit: 36, empActivate: 37, empDeactivate: 38, empPswdReset: 39, empUpload: 40,
    changePassword: 41, forgotPassword: 42, createPassword: 43,
    login: 19, logout: 20, acceptTC: 21,
    rosterChange: 102,
    baselineRecord: 103,
    syncStart: 106, syncComplete: 107, syncFail: 108
};

const user = [
    actions.userAdd, actions.userEdit,
    actions.userDeactivate, actions.userActivate,
    actions.userUpload, actions.userPswdReset
];
const emp = [
    actions.empAdd, actions.empEdit,
    actions.empDeactivate, actions.empActivate,
    actions.empUpload, actions.empPswdReset
];
const org = [
    actions.orgAdd, actions.orgEdit,
    actions.orgDeactivate, actions.orgActivate,
    actions.orgUpload,
];
const customer = [
    actions.customerAdd, actions.customerEdit,
    actions.customerDeactivate, actions.customerActivate,
];
const profile = [
    actions.profileAdd, actions.profileEdit, -1, -1,
    actions.profileUpload, -1, actions.profileDelete
];
const test = [
    actions.testRecord, actions.baselineRecord,
    actions.testEdit, actions.testShare,
    actions.testDownload, actions.testDelete
];

const keys = ['user', 'employee', 'organization', 'customer', 'profile'];
const subjects = [user, emp, org, customer, profile];

export default class Activity {
    private activity: any;

    constructor(activity: any) {
        this.activity = activity;
    }

    public getActivityInfo() {
        let type = this.activity.type;
        let data = JSON.parse(this.activity.data);
        let info;
        for (let i = 0; i < subjects.length; i++) {
            if (subjects[i].indexOf(type) > -1) {
                return this.getInfoBySubject(keys[i], subjects[i].indexOf(type) + 1, data);
            }
        }
        if (test.indexOf(type) > -1) {
            return this.getTestActivity(test.indexOf(type) + 1, data);
        } else {
            switch (type) {
                case actions.acceptTC:
                    info = { action: 'accept', object: 'terms and conditions' };
                    break;
                case actions.login:
                    info = { action: 'log', object: 'in' };
                    break;
                case actions.logout:
                    info = { action: 'log', object: 'out' };
                    break;
                case actions.shareUserActivate:
                    info = {
                        action: 'activate',
                        object: <span>share of user <b>{data.firstname} {data.lastname}</b></span>
                    };
                    break;
                case actions.shareUserDeactivate:
                    info = {
                        action: 'deactivate',
                        object: <span>share of user <b>{data.firstname} {data.lastname}</b></span>
                    };
                    break;
                case actions.changePassword:
                    info = { action: 'change', object: 'password' };
                    break;
                case actions.forgotPassword:
                    info = { action: 'request', object: 'for password change' };
                    break;
                case actions.createPassword:
                    info = { action: 'create', object: 'password' };
                    break;
                case actions.syncStart:
                    info = {
                        action: 'start',
                        object: data.message.charAt(0) === 'I' ? 'initial sync' : 'sync'
                    };
                    break;
                case actions.syncComplete:
                    info = { action: 'complete', object: 'sync' };
                    break;
                case actions.syncFail:
                    info = { action: 'fail', object: 'to complete sync' };
                    break;
                case actions.rosterChange:
                    info = {
                        action: 'change',
                        object: <span>organization of <b>{data.firstname} {data.lastname}</b></span>,
                        preps: <span>from {data.organization} to <b>{data.neworganization}</b></span>
                    };
                    break;
                default: info = {};
            }
            return info;
        }
    }

    private getInfoBySubject(subject: any, index: any, data: any) {
        let names: any = [subject];
        let customer1 = this.activity.customer ? this.activity.customer.name : null;
        let customer2 = data.customer ? data.customer.name : null;
        let preps: any = [];
        // push preposition subject
        if (data.firstname) {
            if (!data.organization && customer1 === customer2) {
                names = ['self'];
            } else {
                names.push(<b> {data.firstname} {data.lastname}</b>);
            }
        } else if (data.username) {
            if (subject === 'customer') {
                names.push(<span><b> {data.customername}</b> with user</span>);
            }
            names.push(<b> {data.username}</b>);
        }
        // push preposition object
        if (data.organization) {
            if (data.firstname || data.uploadcount > -1) {
                preps.push(<span>in organization <b>{data.organization}</b></span>);
            } else {
                preps.push(<b>{data.organization} </b>);
            }
        }
        if (customer2 && (customer2 !== data.organization)) {
            preps.push(<span>in customer <b>{data.customer.name}</b></span>);
        }
        let info;
        switch (index) {
            case 1: info = { action: 'create', object: <span>{...names}</span>, preps: <span>{...preps}</span> };
                    break;
            case 2: info = { action: 'edit', object: <span>{...names}</span>, preps: <span>{...preps}</span> };
                    break;
            case 3: info = { action: 'deactivate', object: <span>{...names}</span>, preps: <span>{...preps}</span> };
                    break;
            case 4: info = { action: 'activate', object: <span>{...names}</span>, preps: <span>{...preps}</span> };
                    break;
            case 5: info = {
                        action: data.uploadcount > 0 ? 'upload' : 'update',
                        object: (
                            <span><b>{data.uploadcount > 0 ? data.uploadcount : data.updatecount} </b>
                                {subject + 's'}</span>
                        ),
                        preps: (
                            (data.uploadcount > 0 && data.updatecount > 0)
                                ? <span>and updated <b>{data.updatecount}</b> {subject + 's'} {...preps}</span>
                                : <span>{...preps}</span>
                        )
                    };
                    break;
            case 6: info = {
                        action: 'send',
                        object: 'password reset request',
                        preps: <span>to {...names}</span>
                    };
                    break;
            case 7: info = { action: 'delete', object: <span>{...names}</span> };
                    break;
            default: info = {};
        }
        return info;
    }

    private getTestActivity(index: any, data: any) {
        let object = <span>test of <b>{data.firstname + ' ' + data.lastname}</b></span>;
        let preps = <span>from organization<b> {data.organization}</b></span>;
        let info;
        switch (index) {
            case 1: info = { action: 'record', object, preps };
                    break;
            case 2: info = {
                        action: 'record', preps,
                        object: <span>baseline of <b>{data.firstname + ' ' + data.lastname}</b></span>
                    };
                    break;
            case 3: info = {
                        action: 'edit',
                        object: <span>test of <b>{data.player}</b></span>,
                        preps: data.organization ? preps : ''
                    };
                    break;
            case 4: info = {
                        action: 'share',
                        object: <span><b>{data.testcount}</b> tests</span>,
                        preps: <span>to<b> {data.usercount}</b> users</span>
                    };
                    break;
            case 5: info = {
                        action: 'download', object,
                        preps: <span>from organization<b> {data.organizationname}</b></span>
                    };
                    break;
            case 6: info = { action: 'delete', object, preps };
                    break;
            default: info = {};
        }
        return info;
    }
}


// WEBPACK FOOTER //
// ./src/components/activityFeed/Activity.tsx